/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { LocalizedBrandService } from './model/localizedBrandService';

export const apiFrontendServiceLandingCountryspecificRetrieve = (
  countryUrlPrefix: string,
  serviceLandingSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LocalizedBrandService>({
    url: `/api/v7/frontend/service-landing/${countryUrlPrefix}/${serviceLandingSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendServiceLandingCountryspecificRetrieveQueryKey = (
  countryUrlPrefix?: string,
  serviceLandingSlug?: string
) => {
  return [`/api/v7/frontend/service-landing/${countryUrlPrefix}/${serviceLandingSlug}/`] as const;
};

export const getApiFrontendServiceLandingCountryspecificRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendServiceLandingCountryspecificRetrieveQueryKey(
      countryUrlPrefix,
      serviceLandingSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>
  > = ({ signal }) =>
    apiFrontendServiceLandingCountryspecificRetrieve(countryUrlPrefix, serviceLandingSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && serviceLandingSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendServiceLandingCountryspecificRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>
>;
export type ApiFrontendServiceLandingCountryspecificRetrieveQueryError = ErrorType<unknown>;

export function useApiFrontendServiceLandingCountryspecificRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingCountryspecificRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendServiceLandingCountryspecificRetrieveQueryOptions(
    countryUrlPrefix,
    serviceLandingSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
